// const API_KEY = '5e62b2453973c629f1496ace3a4b7719';
const API_KEY = '5c476485a2355f460fe2a5a523d9d1d5';

export default API_KEY;
